import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ABOUT, QUOTES, CHI_SONO, PHOTOS } from "@/lib/constants";
import { Reveal } from "./Reveal";

const tints = ["bg-lavender/15 text-lavender-deep", "bg-ocean/20 text-ocean-deep", "bg-green/20 text-green-deep", "bg-lavender/15 text-lavender-deep"];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="about" ref={ref} className="px-5 sm:px-8 lg:px-12 py-24 sm:py-36" data-testid="about">
      {/* Intro + big quote */}
      <Reveal className="mx-auto max-w-4xl text-center">
        <p className="mb-5 text-xs uppercase tracking-[0.3em] text-lavender-deep">L’esperienza</p>
        <h2 className="font-serif tracking-tightest text-4xl sm:text-6xl lg:text-7xl leading-[1.02] text-balance text-navy">
          Non riportiamo indietro il tempo. Riportiamo alla luce quello che il tempo non è riuscito a cancellare.
        </h2>
      </Reveal>

      {/* Portrait + chi sono */}
      <div className="mx-auto mt-20 grid max-w-6xl grid-cols-1 items-center gap-10 lg:grid-cols-12 sm:mt-28">
        <Reveal className="lg:col-span-6">
          <div className="overflow-hidden rounded-[2rem] glass-strong p-2.5">
            <motion.div style={{ y }} className="overflow-hidden rounded-[1.6rem]">
              <img src={PHOTOS.portrait} alt="Le Cosplay Singers" className="aspect-[4/3] w-full object-cover" />
            </motion.div>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6">
          <p className="text-xs uppercase tracking-[0.3em] text-lavender-deep">Chi sono, davvero</p>
          <p className="mt-5 font-serif text-2xl sm:text-3xl leading-snug text-navy text-balance">{CHI_SONO}</p>
        </Reveal>
      </div>

      {/* Numbered chapters */}
      <div className="mx-auto mt-20 grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-2 sm:mt-28">
        {ABOUT.map((c, i) => (
          <Reveal key={c.n} delay={(i % 2) * 0.08}>
            <div className="group h-full rounded-[1.75rem] glass p-8 transition-transform duration-500 hover:-translate-y-1.5">
              <div className={`mb-6 flex h-14 w-14 items-center justify-center rounded-2xl font-serif text-2xl ${tints[i]}`}>
                {c.n}
              </div>
              <h3 className="font-serif text-2xl tracking-tight text-navy">{c.title}</h3>
              <p className="mt-4 text-lg leading-relaxed text-navy-soft">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Closing pull-quote */}
      <Reveal className="mx-auto mt-24 max-w-4xl text-center">
        <p className="font-serif italic text-3xl sm:text-5xl leading-tight text-lavender-deep text-balance">
          “{QUOTES.origin}”
        </p>
      </Reveal>
    </section>
  );
};
